import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCode } from '@/fontawesome';
import type { ChatMessage } from '@/models/chat-message';

interface SystemMessageProps {
  message: ChatMessage;
}

export default function SystemMessage({ message }: SystemMessageProps) {
  return (
    <div className="my-3">
      <div className="bg-gray-100 dark:bg-gray-700 rounded-lg p-3 w-full">
        <div className="flex items-start space-x-3">
          <div className="flex-shrink-0">
            <FontAwesomeIcon icon={faCode} className="w-4 h-4 text-gray-600 dark:text-gray-400" />
          </div>
          <div className="flex-1 min-w-0">
            <div className="text-sm font-medium text-gray-800 dark:text-gray-200 mb-1">
              System Prompt
            </div>
            {message.content && (
              <div className="bg-gray-50 dark:bg-gray-800 rounded p-2 max-h-20 overflow-auto w-full">
                <pre className="whitespace-pre text-xs font-mono text-gray-700 dark:text-gray-300 w-full overflow-x-auto block">
                  {message.content}
                </pre>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}